import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-bs-theme"]
const _hoisted_2 = { class: "container-md" }
const _hoisted_3 = { class: "row main-outline" }
const _hoisted_4 = { class: "col-md-12 col-12" }
const _hoisted_5 = { class: "p-4" }
const _hoisted_6 = { class: "stylish-border-bottom" }
const _hoisted_7 = { class: "row main-outline" }
const _hoisted_8 = { class: "fs190 italic main-outline d-flex justify-content-between align-items-center" }
const _hoisted_9 = { class: "menu-button" }
const _hoisted_10 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ThemeToggleButton = _resolveComponent("ThemeToggleButton")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    "data-bs-theme": _ctx.themeStore.isDarkMode ? 'dark' : 'light'
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_router_link, {
                    class: "secondary-color mb-0",
                    title: "home",
                    to: "/"
                  }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode(" Wiki break ")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("button", _hoisted_9, [
                    _createVNode(_component_router_link, { to: { name: 'home' } }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createElementVNode("i", { class: "secondary-color bi bi-house" }, null, -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_ThemeToggleButton)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_router_view)
            ])
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}